import { Component, AfterViewInit, ViewChild, ElementRef, OnInit } from '@angular/core';

import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first } from 'rxjs/operators';

import { LoaderTheme } from '@fcom/ui-components';

import { UpgradePaymentService } from '../../services/upgrade-payment.service';
import { State } from '../../interfaces/store.interface';
import { getStatusPending } from '../../store/selectors';
import { UpgradeAnalyticsService } from '../../services/upgrade-analytics.service';

@Component({
  selector: 'fin-upgrade-review',
  templateUrl: 'review.component.html',
  styleUrls: ['review.component.scss'],
})
export class ReviewComponent implements OnInit, AfterViewInit {
  readonly LoaderTheme = LoaderTheme;

  selectedPayments$: Observable<string[]>;
  loading$: Observable<boolean>;

  @ViewChild('reviewHeading', { static: false }) reviewHeading: ElementRef;

  constructor(
    private store: Store<State>,
    private upgradePaymentService: UpgradePaymentService,
    private upgradeAnalyticsService: UpgradeAnalyticsService
  ) {}

  ngOnInit(): void {
    this.selectedPayments$ = this.upgradePaymentService.getAllSelectedPayments().pipe(first());
    this.loading$ = this.store.pipe(select(getStatusPending));
    this.upgradeAnalyticsService.sendViewCartEvent();
  }

  ngAfterViewInit(): void {
    this.reviewHeading.nativeElement.focus();
  }
}
